export const TZ = "America/Santiago";

export const fmtDateTime = (iso, lang = "es") =>
  iso
    ? new Intl.DateTimeFormat(lang === "es" ? "es-CL" : "en-GB", {
        timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      }).format(new Date(iso))
    : "—";

export const fmtTime = (iso, lang = "es") =>
  iso ? new Intl.DateTimeFormat(lang === "es" ? "es-CL" : "en-GB", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }).format(new Date(iso)) : "—";

export const todayCL = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const kg = (v) => (v === null || v === undefined ? "—" : `${Number(v).toLocaleString("es-CL", { maximumFractionDigits: 1 })} kg`);
